// Türkiye cep telefonu numaraları için ortak biçimlendirme yardımcıları.
// Depolama/arama tarafında hep ham 11 haneli rakam dizisi (ör. "05551234567") kullanılır;
// sadece input alanında görüntü amaçlı "0 555 123 45 67" biçimi uygulanır.

// Kullanıcının girdiği herhangi bir metni ham (boşluksuz) telefon rakamlarına çevirir.
// Başa otomatik "0" ekler, art arda yazılan fazladan sıfırları tek sıfıra indirger,
// 11 haneyi aşan girişleri keser.
export const normalizePhoneDigits = (input) => {
  let digits = (input || '').replace(/\D/g, '');
  if (!digits) return '';
  digits = digits.replace(/^0+/, '0');
  if (!digits.startsWith('0')) digits = '0' + digits;
  return digits.slice(0, 11);
};

// Ham rakamları "0 555 123 45 67" (3-3-2-2) biçiminde görüntülenecek metne çevirir.
export const formatPhoneDisplay = (input) => {
  const digits = normalizePhoneDigits(input);
  if (!digits) return '';
  const groups = [digits.slice(0, 1), digits.slice(1, 4), digits.slice(4, 7), digits.slice(7, 9), digits.slice(9, 11)];
  return groups.filter(Boolean).join(' ');
};

// 0 dahil tam 11 hane girilmiş mi kontrol eder.
export const isPhoneComplete = (input) => normalizePhoneDigits(input).length === 11;
